<template>
  <div class="content--sinoreg RelacaoRegistros">
    <header-blue>
      Cumprimento de Pedidos
    </header-blue>

    <!-- Filtros -->
    <form class="mt-3 mb-4"
          action="">
      <div class="d-flex align-items-end">
        <CustomInput
          class="col-2 mr-3"
          name="numero_pedido"
          label="Número do Pedido"
          :initial-value="form.numero_pedido"
          type="text" 
          @blur="setValueInput" />

        <div class="col-5 mr-3 d-flex flex-column justify-content-end">
          <label for="data-cumprimento"
                 style="font-size: 1.13rem;"
                 class="label-custom">Período de Cumprimento:</label>

          <div class="d-flex align-items-end">
            <input
              id="data-cumprimento-start"
              v-model="form.data_cumprimento_start"
              type="date"
              class="form-control mr-3">
  
            <span class="mr-3">até</span>

            <input
              id="data-cumprimento-end"
              v-model="form.data_cumprimento_end"
              type="date"
              class="form-control">
          </div>
        </div>

        <CustomInput
          class="col-3 mr-4"
          name="usuario_cumpriu_pedido"
          label="Usuário que cumpriu o pedido"
          :initial-value="form.usuario_cumpriu_pedido"
          type="text" 
          @blur="setValueInput" />

        <CustomButton text="Filtrar"
                      variant="secondary"
                      @click="buscarPedidos" />
      </div>
    </form>

    <hr>
    <div class="d-flex justify-content-end pr-5">
      <b-button
        variant="outline-secondary"
        @click="imprimir">
        <icon-svg icon="print"
                  class="icon--xs" 
                  style="fill: currentColor;" />
        Imprimir
      </b-button>
    </div>

    <!-- Tabela que exibe os pedidos cumpridos -->
    <TabelaPedidos :pedidos="pedidos" />

    <!-- Paginação da lista de pedidos cumpridos -->
    <Pagination v-if="pedidos.length"
                :per-page="perPage"
                :page="page"
                :last-page="lastPage"
                @onPreviousPage="buscarPedidos(page - 1)"
                @onNextPage="buscarPedidos (page + 1)" />

    <ModalImpressao :url="urlRecibo"
                    @close="() => urlRecibo = null" />
  </div>
</template>

<script>
  /* components */
  import HeaderBlue from "@/components/SofiaRei/Headers/HeaderBlue"
  import CustomInput from '@/components/CustomInputs/CustomInput'
  import CustomButton from '@/components/CustomButton/CustomButton'
  import TabelaPedidos from "@/components/SofiaRei/Relatorios/TabelaPedidos"
  import Pagination from "@/components/SofiaRei/Pagination.vue"
  import ModalImpressao from '@/components/ModalImpressao/ModalImpressao'

  /* services */
  import CertidoesCRCService from '@/services/CertidoesCRCService'
  import CumprimentoPedidosService from '@/services/Relatorios/CumprimentoPedidosService'

  /* others */
  import { mapGetters } from 'vuex'

  export default {
    name: "CumprimentoPedidos",
    components: {
      HeaderBlue,
      CustomInput,
      CustomButton,
      TabelaPedidos,
      Pagination,
      ModalImpressao
    },
    data () {
      return {
        pedidos: [],
        form: {
          numero_pedido: null,
          data_cumprimento_start: null,
          data_cumprimento_end: null,
          usuario_cumpriu_pedido: null
        },
        page: 1,
        lastPage: 1,
        perPage: 10,
        urlRecibo: null
      }
    },
    computed: {
      ...mapGetters({
        cartorioObj: 'auth/getCartorioObj'
      })
    },
    mounted () {
      // busca inicial
      this.buscarPedidos()
    },
    methods: {
      async buscarPedidos (page = 1) {
        try {
          loader({active: true, text: ""})

          const temFiltro = this.form.numero_pedido || this.form.data_cumprimento_start || this.form.data_cumprimento_end || this.form.usuario_cumpriu_pedido
          const params = temFiltro ? { ...this.form, page, perPage: this.perPage } : { page, perPage: this.perPage}

          // Faz a requisição para a API para obter a lista de pedidos cumpridos com base nos filtros e paginação
          const res = await CertidoesCRCService.obterPedidosCumpridos(params)

          if (res.data.pedidos.length) {
            this.pedidos = res.data.pedidos
            this.page = res.data.meta.page
            this.lastPage = res.data.meta.lastPage
          } else  {
            this.pedidos = []
            this.displayError("", "Nenhum pedido cumprido foi encontrado!")
          }
        } catch (error) {
          this.displayError("Erro!", error)
        } finally {
          loader({active: false, text: ""})
        }
      },
      setValueInput (nome, value) {
        this.form[nome] = value
      },
      async imprimir () {
        try {
          loader({ text: 'Aguarde...', active: true })
          this.urlRecibo = null

          const payload = {
            filtro: {
              cartorio: {
                nome: this.cartorioObj.nome,
                cns: this.cartorioObj.cns,
                nome_oficial: this.cartorioObj.nome_oficial,
                endereco: {
                  cidade: this.cartorioObj.endereco.cidade,
                  uf: this.cartorioObj.endereco.uf
                }
              },
              periodoDeCumprimento: {
                inicio: this.form.data_cumprimento_start,
                fim: this.form.data_cumprimento_end
              }
            },
            data: this.pedidos
          }

          this.urlRecibo = await CumprimentoPedidosService.gerarRelatorioCumprimentoPedidos(payload)
          loader({ text: '', active: false })
        } catch (e) {
          loader({ text: '', active: false })
          this.displayError("", "Não foi possível imprimir o relatório de cumprimento de pedidos. Tente novamente.")
        }
      },
      displayError (title, text, html) {
        objSwal.error.title = title
        objSwal.error.text = text
        objSwal.error.html = html

        return Swal.fire(objSwal.error).then(() => {
          objSwal.error.title = ''
          objSwal.error.text = ''
          objSwal.error.html = ''
        })
      }
    }
  }
</script>

<style lang="scss">
  @import "./src/scss/_components/resumos";

  .label-custom {
    font-weight: 500;
    font-size: 17px;
  }
</style>
